<template>
    <div>
        <AppBreadCrumb
            :paths="[{ title: $t('message.integrationsPage.copilotPrompts') }]"
            :select="true"
        />
        <div class="copilot-prompts-page-wrapper">
            <CoPilotPrompts :saveCopilotPrompts="saveCopilotPrompts" />
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import AppBreadCrumb from "../../../../components/common/AppBreadCrumb.vue";
import CoPilotPrompts from "../../Settings/pages/copilot-prompts/CoPilotPrompts.vue";
import { sendSocketMessage } from "../../../../utils/socketStream";

export default {
    name: "CoPilotPromptsPage",
    components: { AppBreadCrumb, CoPilotPrompts },
    computed: {
        ...mapState({
            settings: (state) => state.setting.settings,
            site: (state) => state.site.site,
        }),
    },
    methods: {
        ...mapActions({
            updateSettings: "setting/updateSettings",
            setSettingValue: "setting/setSettingValue",
        }),
        saveCopilotPrompts(promptPayload) {
            var self = this;
            var currentPrompts = (self.settings && self.settings.copilotPrompts) || {};
            var merged = Object.assign({}, currentPrompts, promptPayload);
            self.setSettingValue({ key: "copilotPrompts", value: merged });
            return self.updateSettings(self.settings).then(function () {
                sendSocketMessage("user settings-updated", {
                    siteId: self.site._id,
                });
            });
        },
    },
};
</script>

<style scoped lang="scss">
.copilot-prompts-page-wrapper {
    padding: 20px;
}
</style>
